import { render, staticRenderFns } from "./home.html?vue&type=template&id=37d131fa&scoped=true&external"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=37d131fa&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=37d131fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d131fa",
  null
  
)

export default component.exports